import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';

import App from './App';
import * as serviceWorker from './serviceWorker';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from "./helpers/theme";
import { SnackbarProvider } from 'notistack';

ReactDOM.render(
  <React.StrictMode>
      <ThemeProvider theme={theme}>
          <SnackbarProvider maxSnack={1}>
            <App />
          </SnackbarProvider>
      </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
